const keySessionStorage = {
  keyUser: 'user-student - key',
  userAdmin: 'KEY-USER-AMIN - DASHBOARD',
  resultVocational: 'user-data final results',
}

export default keySessionStorage
